import { render, staticRenderFns } from "./JobStatusChanged.vue?vue&type=template&id=774382c6"
import script from "./JobStatusChanged.vue?vue&type=script&lang=js"
export * from "./JobStatusChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports